import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { environment } from "@env/environment";
import amplitude from "@libs/amplitude-js";

declare const ym: Function;

@Injectable({
  providedIn: "root",
})
export class MonitoringService {
  private readonly http = inject(HttpClient);

  monitorCurrentUser(user: any) {
    this.monitorByAmplitude(user);
    if (environment.production && (window as any).ym) {
      this.monitorByYandex(user);
    }
  }

  sendEventToAplitude(event_name: string, props: any = {}): void {
    amplitude.logEvent(event_name, props);
  }

  // sendEvent(event_name: string, props: any = {}): void {
  //   const url = environment.eventMonitoringDomain;

  //   this.http
  //     .post(
  //       url,
  //       { event_name, ...props },
  //       { headers: { [SKIP_ERROR_NOTIFY]: "true" } },
  //     )
  //     .pipe(take(1))
  //     .subscribe();
  // }

  private monitorByYandex(user: any): void {
    ym(environment.yandexMetrika.id, "userParams", user.user_profile);
  }

  private monitorByAmplitude(user: any): void {
    amplitude.setUserId(user.id);
  }
}
